module.exports = __webpack_public_path__ + "static/media/githubactions.889c4151.svg";